import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, Grid } from "@mui/material";
import FormikControl from "../../Components/Formik/FormikControl/FormikControl";
import { Form, Formik } from "formik";
import { useTheme } from "@mui/material";
import { useChangePasswordProfile, useEditUser, useGetUserInfo } from "./Hooks";
import LoadingScreen from "../Organization/Chart/Components/LoadingScreen";
import * as Yup from "yup";
import ToastCustomise from "../../General/Components/ToastCustomise/ToastCustomise";
import { actionsAccess } from "../../General/Components/ActionControlesUiAccess";
import useGetUserId from "../../General/Hooks/getUserid";
import useDeviceType from "./Hooks/useDeviceType";
import { deleteSetting } from "../../utils/Db";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

function ProfileItems() {
  const device = useDeviceType();
  const [value, setValue] = React.useState(0);
  const theme = useTheme().palette.mode;
  /*================================ Toast ==============================*/
  const [openToast, setOpenToast] = useState(null);
  const [toastText, setToastText] = useState([]);
  const [colorToas, setColorToast] = useState("");

  const handleSuccess = (text) => {
    setToastText((prev) => [
      ...prev,
      { text: text ? text : "با موفقیت انجام شد" },
    ]);
    setOpenToast(true);
    setColorToast("rgba(76, 175, 80, 1)");
  };

  const handleFailed = (text) => {
    setOpenToast(true);
    setToastText((prev) => [
      ...prev,
      { text: text ? text : "  خطایی رخ داد !" },
    ]);
    setColorToast("rgba(212, 22, 79, 1)");
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabStyle = {
    fontSize: "1rem",
    color: theme === "dark" ? "#fff" : "#000",
    borderColor: "rgba(30, 106, 253, 1)",
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: "background.paper",
        display: "flex",
        height: "100%",
        minHeight: "40rem",
        flexDirection: device === "mobile" ? "column" : "row",
      }}
    >
      <Tabs
        orientation={device === "mobile" ? "horizontal" : "vertical"}
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{
          borderRight: 1,
          borderColor: "divider",
          width: device === "mobile" ? "100%" : "20%",
        }}
      >
        <Tab
          label={<Typography style={tabStyle}> حساب کاربری</Typography>}
          {...a11yProps(0)}
        />
        <Tab
          label={<Typography style={tabStyle}> تنظیمات </Typography>}
          {...a11yProps(1)}
        />
        <Tab
          label={<Typography style={tabStyle}>رمز عبور</Typography>}
          {...a11yProps(2)}
        />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Grid container display={"flex"} justifyContent={"space-between"}>
          <Grid item xs={12} lg={12} display={"flex"}>
            {userAccount(theme)}
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Alarm />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <PassWord handleSuccess={handleSuccess} handleFailed={handleFailed} />
      </TabPanel>

      {/* /*================================== Return Toast ======================================*/}
      {openToast && (
        <Box sx={{ position: "absolute" }}>
          <ToastCustomise
            style={{ padding: "4px", fontSize: "12px" }}
            gutter={3}
            openToast={openToast}
            setOpenToast={setOpenToast}
            text={toastText}
            setToastText={setToastText}
            key={"1"}
            color={colorToas}
          />
        </Box>
      )}
    </Box>
  );
}

export default ProfileItems;

/* -------------------------------- //setting ------------------------------- */
const Alarm = () => {
  const cleareIndexDb = () => {
    deleteSetting("dashboardAccrdion");
    deleteSetting("dashboardSettings");
    setTimeout(() => {
      const url =
        window.location.origin +
        window.location.pathname +
        "?nocache=" +
        new Date().getTime();
      window.location.replace(url);
    }, 1000);
  };
  return (
    <Box>
      {" "}
      <Typography color={"#1E6AFD"} fontSize={"1.2rem"}>
        تنظیمات
      </Typography>
      <Box>
        <Button
          onClick={() => cleareIndexDb()}
          sx={{
            background: "#1E6AFD",
            color: "white",
            padding: "0.5rem",
            margin: "0.5rem",
            ":hover": { background: "#1E6AFD" },
          }}
        >
          {" "}
          بارگزاری دوباره index db{" "}
        </Button>
      </Box>
    </Box>
  );
};

/*================================ UserUploadImage ==============================*/
const UserUploadImage = ({
  theme,
  setProfile,
  profile,
  setImagePreview,
  imagePreview,
}) => {
  const uploadImageHandler = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfile({ url: file, type: "preview" });
      const objectUrl = URL.createObjectURL(file);
      setImagePreview(objectUrl);
    }
  };

  return (
    <>
      {profile ? (
        profile.type === "preview" ? (
          <img
            style={{
              width: "250px",
              height: "250px",
              borderRadius: "8px",
              objectFit: "contain",
            }}
            src={imagePreview}
            alt="profile"
          />
        ) : (
          <img
            style={{
              width: "250px",
              height: "250px",
              borderRadius: "8px",
              objectFit: "contain",
            }}
            src={profile.url}
            alt="profile"
          />
        )
      ) : (
        <Box
          sx={{
            background: theme === "dark" ? "#262D39" : "#F7FBFF",
            borderRadius: "24px",
            position: "relative",
            width: "100%",
            height: "80%",
            marginLeft: "auto",
            marginRight: "0",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="124"
            height="125"
            viewBox="0 0 124 125"
            fill="none"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
            }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M62 6.95898C48.4461 6.95898 37.4584 17.9467 37.4584 31.5007C37.4584 45.0546 48.4461 56.0423 62 56.0423C75.554 56.0423 86.5417 45.0546 86.5417 31.5007C86.5417 17.9467 75.554 6.95898 62 6.95898ZM45.2084 31.5007C45.2084 22.2269 52.7263 14.709 62 14.709C71.2738 14.709 78.7917 22.2269 78.7917 31.5007C78.7917 40.7744 71.2738 48.2923 62 48.2923C52.7263 48.2923 45.2084 40.7744 45.2084 31.5007Z"
              fill="#C7C8CC"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M62 63.7923C50.0467 63.7923 39.0338 66.5094 30.8732 71.0997C22.834 75.6218 16.7917 82.4753 16.7917 90.9173L16.7914 91.4441C16.7855 97.447 16.7782 104.981 23.3865 110.362C26.6388 113.011 31.1885 114.894 37.3355 116.138C43.4996 117.386 51.5335 118.042 62 118.042C72.4665 118.042 80.5005 117.386 86.6646 116.138C92.8116 114.894 97.3613 113.011 100.614 110.362C107.222 104.981 107.215 97.447 107.209 91.4441L107.208 90.9173C107.208 82.4753 101.166 75.6218 93.1269 71.0997C84.9663 66.5094 73.9534 63.7923 62 63.7923ZM24.5417 90.9173C24.5417 86.5187 27.7522 81.7473 34.6727 77.8544C41.4718 74.0299 51.1256 71.5423 62 71.5423C72.8745 71.5423 82.5283 74.0299 89.3274 77.8544C96.2479 81.7473 99.4584 86.5187 99.4584 90.9173C99.4584 97.6743 99.2501 101.478 95.7198 104.353C93.8054 105.912 90.6052 107.433 85.1271 108.542C79.6662 109.648 72.2002 110.292 62 110.292C51.7999 110.292 44.3339 109.648 38.873 108.542C33.3949 107.433 30.1947 105.912 28.2803 104.353C24.75 101.478 24.5417 97.6743 24.5417 90.9173Z"
              fill="#C7C8CC"
            />
          </svg>
        </Box>
      )}

      <Button
        sx={{
          border: "1px solid rgba(30, 106, 253, 0.50)",
          background: "transparent",
          padding: "0.5rem 2rem",
          margin: "0.5rem auto",
          display: "flex",

          justifyContent: "center",
        }}
      >
        <div className="file">
          <label for="input-file" style={{ color: "#1E6AFD" }}>
            افزودن عکس
          </label>

          <input
            id="input-file"
            hidden
            type="file"
            onChange={uploadImageHandler}
          />
        </div>
      </Button>
    </>
  );
};

/*================================ userAccount ==============================*/
const userAccount = (theme) => {
  const GetUserAccount = actionsAccess("Account", "GetUserById");
  const { userId } = JSON.parse(localStorage.getItem("userInfo"));
  const { data } = useGetUserInfo(GetUserAccount ? userId : "");
  const [profile, setProfile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const initialForm = {
    userName: data?.userName,
    email: data?.email,
    phoneNumber: data?.phoneNumber,
  };
  //*Update Profile Info
  const { mutate } = useEditUser();
  const submitForm = (data) => {
    const formData = new FormData();
    formData.append("userName", data.userName);
    formData.append("email", data.email);
    formData.append("phoneNumber", data.phoneNumber);
    formData.append("Picture", profile.url);
    formData.append("id", userId);
    if (imageUrl && imageUrl != null) {
      formData.append("imageUrl", imageUrl);
    }
    mutate(formData);
  };
  const [loading, setloading] = useState(true);
  useEffect(() => {
    if (data) {
      setProfile({ url: data?.imageUrl, type: "recive" });
      setImageUrl(data.imageUrl);
    }
    setTimeout(() => {
      setloading(false);
    }, 1000);
  }, [data]);

  if (loading) {
    return <LoadingScreen />;
  } else if (GetUserAccount && !loading) {
    return (
      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <Typography color={"#1E6AFD"} fontSize={"1.2rem"}>
          {" "}
          حساب کاربری
        </Typography>
        <Formik
          enableReinitialize
          handleReset
          initialValues={initialForm}
          onSubmit={(data) => submitForm(data)}
        >
          {({
            values,
            isValid,
            dirty,
            setFieldValue,
            errors,
            touched,
            handleChange,
            resetForm,
          }) => (
            <Form style={{ width: "100%" }}>
              <Grid container>
                <Grid item xs={12} lg={8}>
                  <Box margin={"0.5rem 0"}>
                    <FormikControl
                      control="input"
                      label="نام کاربری "
                      name="userName"
                      value={""}
                      disabled
                    />
                  </Box>
                  <Box margin={"0.5rem 0"} component={"div"}>
                    <FormikControl
                      control="input"
                      label="ایمیل"
                      name="email"
                      value={""}
                    />
                  </Box>
                  <Box margin={"0.5rem 0"} component={"div"}>
                    <FormikControl
                      control="input"
                      label="شماره موبایل"
                      name="phoneNumber"
                      value={""}
                    />
                  </Box>
                  <Box width={"100%"} component={"div"}>
                    <Button
                      type="submit"
                      sx={{
                        width: "98%",
                        margin: "1rem auto",
                        display: "flex",
                        justifyContent: "center",
                        border: "0",
                        padding: "0.7rem",
                        background: "#1E6AFD",
                        borderRadius: "8px",
                        color: "#fff",
                        "&:hover": {
                          background: "#1E6AFD",
                        },
                      }}
                    >
                      {" "}
                      ثبت تغییرات
                    </Button>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <UserUploadImage
                    theme={theme}
                    profile={profile}
                    setProfile={setProfile}
                    imagePreview={imagePreview}
                    setImagePreview={setImagePreview}
                  />
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
};

/*================================ ChangePassword ==============================*/
const PassWord = ({ handleSuccess, handleFailed }) => {
  const GetUserAccount = actionsAccess("Account", "ChangeUserPassword");
  const userId = useGetUserId();

  const initialForm = {
    CurrentPassword: "",
    NewPassword: "",
    id: userId,
  };

  //*validationForm
  const validation = Yup.object({
    CurrentPassword: Yup.string().required(" "),
    NewPassword: Yup.string().required(" "),
  });

  //*Api change password
  const { mutate } = useChangePasswordProfile(handleSuccess, handleFailed);
  return (
    <Box>
      {" "}
      <Typography color={"#1E6AFD"} fontSize={"1.2rem"}>
        {" "}
        رمزعبور
      </Typography>
      <Formik
        enableReinitialize
        handleReset
        initialValues={initialForm}
        validationSchema={validation}
        onSubmit={(data) => mutate(data)}
      >
        {({
          values,
          isValid,
          dirty,
          setFieldValue,
          errors,
          touched,
          handleChange,
          resetForm,
        }) => (
          <Form style={{ width: "100%" }}>
            <Grid container>
              <Grid item xs={12} lg={8}>
                <Box margin={"0.5rem 0"}>
                  <FormikControl
                    control="input"
                    label="پسورد فعلی"
                    name="CurrentPassword"
                    value={""}
                  />
                </Box>
                <Box margin={"0.5rem 0"} component={"div"}>
                  <FormikControl
                    control="input"
                    label="پسوردجدید"
                    name="NewPassword"
                    value={""}
                  />
                </Box>

                <Box width={"100%"} component={"div"}>
                  {GetUserAccount && (
                    <Button
                      type="submit"
                      disabled={isValid ? false : true}
                      sx={{
                        width: "98%",
                        margin: "1rem auto",
                        display: "flex",
                        justifyContent: "center",
                        border: "0",
                        padding: "0.7rem",
                        background: "#1E6AFD",
                        borderRadius: "8px",
                        color: "#fff",
                        "&:hover": {
                          background: "#1E6AFD",
                        },
                      }}
                    >
                      تغییر پسورد
                    </Button>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
